
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TvAirplaneWrap',
  props: {
    showBadge: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['open'],
  computed: {
    ariaLabel(): string {
      return this.showBadge ? '打开投屏内容（有新作品）' : '打开投屏内容';
    },
  },
  methods: {
    handleClick() {
      this.$emit('open');
    },
  },
});
